import { CardImage } from '.';
import Image from 'next/image';
import { getProductURL } from '@/features/navigation/utils/url-helpers';
import { handleImageError } from '@/utils/image-error';
import { ColorType } from './types';
import { AppNextLink } from '../app-next-link';
import { Button } from '../button';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
interface Props {
  slug: string;
  brand: string;
  name: string;
  image: string;
  isLazy?: boolean;
  color: ColorType;
}
export const CommentCard = ({
  brand,
  image,
  isLazy,
  name,
  slug,
  color
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const imageSize = isMobile ? 88 : 104;
  return <AppNextLink prefetch={false} href={getProductURL(slug || '')} className='shadow-s relative flex flex-col items-center gap-2 rounded border border-border-gray-light px-2 py-1 focus-visible:outline-none lg:gap-3 lg:px-3 lg:py-2' data-sentry-element="AppNextLink" data-sentry-component="CommentCard" data-sentry-source-file="comment-card.tsx">
            <div className='flex gap-3 lg:gap-2'>
                <CardImage alt={name} image={image} srcSet={{
        desktop: 130,
        mobile: 175
      }} isLazy={isLazy} imageClassName='h-auto w-22 aspect-square lg:w-26' parentClassName='h-fit my-auto' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="comment-card.tsx" />

                <div className='flex w-full flex-col gap-1'>
                    <span className='text-caption-12 text-text-darkGray lg:text-body-14'>{brand}</span>

                    <h3 className='line-clamp-2 text-caption-12 text-text-black lg:text-body-14'>{name}</h3>

                    {!!color?.name && <div className='mt-1 flex items-center gap-1 lg:mt-2'>
                            {color.image ? <Image src={color.image} alt={color.name} width={16} height={16} className='rounded-full' unoptimized onError={handleImageError} /> : color?.hex && <div className='h-4 w-4 rounded-full' style={{
            backgroundColor: color.hex
          }} />}

                            <span className='text-caption-12 text-text-mediumGray lg:text-body-14'>{color?.name}</span>
                        </div>}
                </div>
            </div>

            <div className='flex w-full items-center justify-between gap-4'>
                <Button graphicStyle='filled' size={isMobile ? 'small' : 'medium'} data-sentry-element="Button" data-sentry-source-file="comment-card.tsx">
                    افزودن دیدگاه
                </Button>
                <Button graphicStyle='outlined' size={isMobile ? 'small' : 'medium'} data-sentry-element="Button" data-sentry-source-file="comment-card.tsx">
                    خرید مجدد
                </Button>
            </div>
        </AppNextLink>;
};